import $ from 'jquery';

class NewsGrid {
	constructor() {
		this.init();
	}

	init() {
		$(function () {
			$('#news-grid .form-select').on('change', function () {
				var url = $(this).val();
				if (url) {
					window.location = url;
				}
				return false;
			});
		});
	}
}

export default NewsGrid;
